import React, { ReactNode } from "react";
import { Button } from "@mui/material";

export type ActionButtonProps = {
  label: string;
  onClick: () => void;
  icon?: ReactNode;
  href?: string;
  target?: "_blank" | "_self" | "_parent" | "_top";
  rel?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  /** "outlined" para a ação secundária (ex.: entrar com o Google). */
  variant?: "contained" | "outlined";
};

/** Botão das telas de entrada (redesign V3): 44px, canto 8px, largura do cartão. */
export const ActionButton: React.FC<ActionButtonProps> = ({
  label,
  onClick,
  icon,
  href,
  target = "_blank",
  rel = "noopener noreferrer",
  disabled = false,
  fullWidth = true,
  variant = "contained",
}) => {
  const outlined = variant === "outlined";
  return (
    <Button
      startIcon={icon}
      variant={variant}
      disableElevation
      onClick={onClick}
      {...(href
        ? {
            href,
            target,
            rel,
          }
        : {})}
      disabled={disabled}
      fullWidth={fullWidth}
      sx={{
        backgroundColor: outlined ? "#ffffff" : "var(--brand)",
        color: outlined ? "var(--text)" : "#ffffff",
        borderColor: outlined ? "#d4d9de" : "transparent",
        borderRadius: "8px",
        height: "44px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        fontFamily: "var(--font-sans)",
        fontSize: "14px",
        fontWeight: outlined ? 500 : 600,
        width: fullWidth ? "100%" : "fit-content",
        paddingInline: "20px",
        textTransform: "none",
        transition: "background-color 0.15s ease",
        lineHeight: "20px",
        "&:hover": {
          backgroundColor: outlined ? "#f3f6fa" : "var(--brand-700)",
          borderColor: outlined ? "#d4d9de" : "transparent",
          color: outlined ? "var(--ink)" : "#ffffff",
        },
      }}
    >
      {label}
    </Button>
  );
};

export default ActionButton;
